<div class="top">
  <div class="heading">
      <span class="fw-bold" style="font-size: 18px; text-transform: uppercase;">Marriage Registration</span>
  </div>
  <i class="material-icons text-danger" role="button" (click)="closeModal()">
      close
  </i>
</div>


<div class="form-wrapper">

  <form [formGroup]="form">

    <div class="collapsable-form-section">
      <div class="collapsable-form-section-heading" role="button" data-bs-toggle="collapse"
        data-bs-target="#bachelorSection" aria-expanded="true">
        BACHELOR DETAILS
      </div>

      <div class="body collapse show" id="bachelorSection">
        <div class="row g-3">

          <div class="col-md-4">
            <div class="field">
              <label class="mb-0 required">SURNAME</label>
              <input type="text" class="form-control mt-0" formControlName="bachelorSurname" maxlength="60" />

            </div>
          </div>

          <div class="col-md-4">
            <div class="field">
              <label class="mb-0 required">FIRST NAME</label>
              <input type="text" class="form-control mt-0" formControlName="bachelorFirstName" maxlength="60" />

            </div>
          </div>

          <div class="col-md-4">
            <div class="field">
              <label class="mb-0 required">MIDDLE NAME</label>
              <input type="text" class="form-control mt-0" formControlName="bachelorMiddleName" maxlength="60" />

            </div>
          </div>

          <div class="col-md-4">
            <div class="field">
              <label class="mb-0 required">DATE OF BIRTH</label>
              <input type="date" class="form-control mt-0" formControlName="bachelorDob" />

            </div>
          </div>

          <div class="col-md-4">
            <div class="field">
              <label class="mb-0 required">PHONE NUMBER</label>
              <input type="text" class="form-control mt-0" formControlName="bachelorPhoneNumber"  />

            </div>
          </div>

          <div class="col-4">
            <div class="field">
              <label for="name" class="required">COUNTRY OF ORIGIN</label>
              <input type="text" class="form-control mt-0" formControlName="bachelorCountry"  />

            </div>
          </div>

          <div class="col-md-4">
            <div class="field">
              <label class="mb-0 required">STATE OF ORIGIN</label>
              <input type="text" class="form-control mt-0" formControlName="bachelorState" />
            </div>
          </div>

          <div class="col-md-4">
            <div class="field">
              <label class="mb-0 required">LGA OF ORIGIN</label>

              <input type="text" class="form-control mt-0" formControlName="bachelorLga" />

            </div>
          </div>

          <div class="col-4">
            <div class="field">
              <label class="mb-0 required">ADDRESS</label>
              <input type="text" class="form-control mt-0" formControlName="bachelorAddress" maxlength="200" />

            </div>
          </div>


          <div class="col-md-4">
            <div class="field">
              <label class="mb-0 required">SIGNATURE</label>
              <div class="mt-2">
                <a [href]="form.get('bachelorSignature').value" target="_blank">
                  <img
                    [src]="form.get('bachelorSignature').value"
                    alt="Signature"
                    class="img-fluid rounded border"
                    style="max-height: 200px; object-fit: contain;"
                  />
                </a>
              </div>

            </div>
          </div>

          <div class="col-md-4">
            <div class="field">
              <label class="mb-0 required">PASSPORT PHOTOGRAPH</label>
              <div class="mt-2">
                <a [href]="form.get('bachelorPassportPhotograph').value" target="_blank">
                  <img
                    [src]="form.get('bachelorPassportPhotograph').value"
                    alt="Passport photograph"
                    class="img-fluid rounded border"
                    style="max-height: 200px; object-fit: contain;"
                  />
                </a>
              </div>
            </div>
          </div>

          <div class="col-md-4">
            <div class="field">
              <label class="mb-0 required">BIRTH CERTIFICATE</label>
              <div class="mt-2">
                <a [href]="form.get('bachelorBirthCertificate').value" target="_blank">
                  <img
                    [src]="form.get('bachelorBirthCertificate').value"
                    alt="Birth Certificate"
                    class="img-fluid rounded border"
                    style="max-height: 200px; object-fit: contain;"
                  />
                </a>
              </div>

            </div>
          </div>

          <div class="col-md-4">
            <div class="field">
              <label class="mb-0 required">DECLARATION / AFFIDAVIT OF AGE</label>
                <div class="mt-2">
                  <a [href]="form.get('bachelorDeclarationOfAge').value" target="_blank">
                    <img
                      [src]="form.get('bachelorDeclarationOfAge').value"
                      alt="Declaration of Age"
                      class="img-fluid rounded border"
                      style="max-height: 200px; object-fit: contain;"
                    />
                  </a>
                </div>

            </div>
          </div>

          <div class="col-md-4">
            <div class="field">
              <label class="mb-0 required">INDIGENE LETTER FROM STATE OF ORIGIN</label>
              <div class="mt-2">
                <a [href]="form.get('bachelorIndigeneCertificate').value" target="_blank">
                  <img
                    [src]="form.get('bachelorIndigeneCertificate').value"
                    alt="Indigene letter"
                    class="img-fluid rounded border"
                    style="max-height: 200px; object-fit: contain;"
                  />
                </a>
              </div>

            </div>
          </div>

          <div class="col-md-4">
            <div class="field">
              <label class="mb-0">INTERNATIONAL PASSPORT (If Living Abroad)</label>
              <div class="mt-2">
                <a [href]="form.get('bachelorInternationalPassport').value" target="_blank">
                  <img
                    [src]="form.get('bachelorInternationalPassport').value"
                    alt="International Passport"
                    class="img-fluid rounded border"
                    style="max-height: 200px; object-fit: contain;"
                  />
                </a>
              </div>


            </div>
          </div>


          <label class="checklist-item mt-4 mb-3">
            <input type="checkbox" formControlName="bachelorHasAnotherMarriage" />
            <small style="font-size: 15px;">Has been married?</small>
          </label>

          <label class="checklist-item mt-4 mb-3">
            <input type="checkbox" formControlName="bachelorIsWidower" />
            <small style="font-size: 15px;">Is a widower?</small>
          </label>

          <label class="checklist-item mt-4 mb-3">
            <input type="checkbox" formControlName="bachelorHasChild" />
            <small style="font-size: 15px;">Has a child or children?</small>
          </label>

          <label class="checklist-item mt-4 mb-3">
            <input type="checkbox" formControlName="bachelorIsDivorce" />
            <small style="font-size: 15px;">Is a divorcee?</small>
          </label>

        </div>


        <div class="form-section mt-4">
          <h5 class="form-section-heading mb-3">WITNESS DETAILS</h5>
          <div class="body">
            <div class="row g-3">

              <div class="col-md-4">
                <div class="field">
                  <label class="mb-0 required">SURNAME</label>
                  <input type="text" class="form-control mt-0" formControlName="bachelorWitnessSurname"
                    maxlength="60" />

                </div>
              </div>

              <div class="col-md-4">
                <div class="field">
                  <label class="mb-0 required">FIRST NAME</label>
                  <input type="text" class="form-control mt-0" formControlName="bachelorWitnessFirstName"
                    maxlength="60" />

                </div>
              </div>

              <div class="col-md-4">
                <div class="field">
                  <label class="mb-0 required">MIDDLE NAME</label>
                  <input type="text" class="form-control mt-0" formControlName="bachelorWitnessMiddleName"
                    maxlength="60" />

                </div>
              </div>

              <div class="col-md-4">
                <div class="field">
                  <label class="mb-0 required">PHONE NUMBER</label>
                  <input type="text" class="form-control mt-0" formControlName="bachelorWitnessPhoneNumber"
                    maxlength="17" />

                </div>
              </div>
              <div class="col-md-4">
                <div class="field">
                  <label class="mb-0 required">EMAIL</label>
                  <input type="text" class="form-control mt-0" formControlName="bachelorWitnessEmail"
                    maxlength="30" />

                </div>
              </div>

              <div class="col-4">
                <div class="field">
                  <label class="mb-0 required">ADDRESS</label>
                  <input type="text" class="form-control mt-0" formControlName="bachelorWitnessAddress"
                    maxlength="200" />

                </div>
              </div>

              <div class="col-md-4">
                <div class="field">
                  <label class="mb-0 required">SIGNATURE</label>
                  <div class="mt-2">
                    <a [href]="form.get('bachelorWitnessSignature').value" target="_blank">
                      <img
                        [src]="form.get('bachelorWitnessSignature').value"
                        alt="Signature"
                        class="img-fluid rounded border"
                        style="max-height: 200px; object-fit: contain;"
                      />
                    </a>
                  </div>


                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>



    <div class="collapsable-form-section">
      <div class="collapsable-form-section-heading" role="button" data-bs-toggle="collapse"
        data-bs-target="#spinsterSection" aria-expanded="true">
        SPINSTER DETAILS
      </div>

      <div class="body collapse show" id="spinsterSection">
        <div class="row g-3 MB-3">

          <div class="col-md-4">
            <div class="field">
              <label class="mb-0 required">SURNAME</label>
              <input type="text" class="form-control mt-0" formControlName="spinsterSurname" maxlength="60" />

            </div>
          </div>

          <div class="col-md-4">
            <div class="field">
              <label class="mb-0 required">FIRST NAME</label>
              <input type="text" class="form-control mt-0" formControlName="spinsterFirstName" maxlength="60" />

            </div>
          </div>

          <div class="col-md-4">
            <div class="field">
              <label class="mb-0 required">MIDDLE NAME</label>
              <input type="text" class="form-control mt-0" formControlName="spinsterMiddleName" maxlength="60" />

            </div>
          </div>

          <div class="col-md-4">
            <div class="field">
              <label class="mb-0 required">DATE OF BIRTH</label>
              <input type="date" class="form-control mt-0" formControlName="spinsterDob" />

            </div>
          </div>

          <div class="col-md-4">
            <div class="field">
              <label class="mb-0 required">PHONE NUMBER</label>
              <input type="text" class="form-control mt-0" formControlName="spinsterPhoneNumber"  />

            </div>
          </div>



          <div class="col-4">
            <div class="field">
              <label for="name" class="required">COUNTRY OF ORIGIN</label>
              <input type="text" class="form-control mt-0" formControlName="spinsterCountry"  />

            </div>
          </div>


          <div class="col-md-4">
            <div class="field">
              <label class="mb-0 required">STATE OF ORIGIN</label>
              <input type="text" class="form-control mt-0" formControlName="spinsterState"  />

            </div>
          </div>

          <div class="col-md-4">
            <div class="field">
              <label class="mb-0 required">LGA OF ORIGIN</label>
              <input type="text" class="form-control mt-0" formControlName="spinsterLga"  />


            </div>
          </div>

          <div class="col-4">
            <div class="field">
              <label class="mb-0 required">ADDRESS</label>
              <input type="text" class="form-control mt-0" formControlName="spinsterAddress" maxlength="200" />

            </div>
          </div>

          <div class="col-md-4">
            <div class="field">
              <label class="mb-0 required">SIGNATURE</label>
              <div class="mt-2">
                <a [href]="form.get('spinsterSignature').value" target="_blank">
                  <img
                    [src]="form.get('spinsterSignature').value"
                    alt="Signature"
                    class="img-fluid rounded border"
                    style="max-height: 200px; object-fit: contain;"
                  />
                </a>
              </div>


            </div>
          </div>

          <div class="col-md-4">
            <div class="field">
              <label class="mb-0 required">PASSPORT PHOTOGRAPH</label>
              <div class="mt-2">
                <a [href]="form.get('spinsterPassportPhotograph').value" target="_blank">
                  <img
                    [src]="form.get('spinsterPassportPhotograph').value"
                    alt="Passport Photograph"
                    class="img-fluid rounded border"
                    style="max-height: 200px; object-fit: contain;"
                  />
                </a>
              </div>
            </div>
          </div>

          <div class="col-md-4">
            <div class="field">
              <label class="mb-0 required">BIRTH CERTIFICATE</label>
              <div class="mt-2">
                <a [href]="form.get('spinsterBirthCertificate').value" target="_blank">
                  <img
                    [src]="form.get('spinsterBirthCertificate').value"
                    alt="Birth Certificate"
                    class="img-fluid rounded border"
                    style="max-height: 200px; object-fit: contain;"
                  />
                </a>
              </div>


            </div>
          </div>

          <div class="col-md-4">
            <div class="field">
              <label class="mb-0 required">DECLARATION / AFFIDAVIT OF AGE</label>
              <div class="mt-2">
                <a [href]="form.get('spinsterDeclarationOfAge').value" target="_blank">
                  <img
                    [src]="form.get('spinsterDeclarationOfAge').value"
                    alt="Declaration of Age"
                    class="img-fluid rounded border"
                    style="max-height: 200px; object-fit: contain;"
                  />
                </a>
              </div>
            </div>
          </div>

          <div class="col-md-4">
            <div class="field">
              <label class="mb-0 required">INDIGENE LETTER FROM STATE OF ORIGIN</label>

              <div class="mt-2">
                <a [href]="form.get('spinsterIndigeneCertificate').value" target="_blank">
                  <img
                    [src]="form.get('spinsterIndigeneCertificate').value"
                    alt="Indigene letter"
                    class="img-fluid rounded border"
                    style="max-height: 200px; object-fit: contain;"
                  />
                </a>
              </div>

            </div>
          </div>

          <div class="col-md-4">
            <div class="field">
              <label class="mb-0 ">INTERNATIONAL PASSPORT (If Living Abroad)</label>
              <div class="mt-2">
                <a [href]="form.get('spinsterInternationalPassport').value" target="_blank">
                  <img
                    [src]="form.get('spinsterInternationalPassport').value"
                    alt="International Passport"
                    class="img-fluid rounded border"
                    style="max-height: 200px; object-fit: contain;"
                  />
                </a>
              </div>


            </div>
          </div>


          <label class="checklist-item mt-4 mb-3">
            <input type="checkbox" formControlName="spinsterHasAnotherMarriage" />
            <small style="font-size: 15px;">Has been married?</small>
          </label>

          <label class="checklist-item mt-4 mb-3">
            <input type="checkbox" formControlName="spinsterIsWidow" />
            <small style="font-size: 15px;">Is a widow?</small>
          </label>

          <label class="checklist-item mt-4 mb-3">
            <input type="checkbox" formControlName="spinsterHasChild" />
            <small style="font-size: 15px;">Has a child or children?</small>
          </label>

          <label class="checklist-item mt-4 mb-3">
            <input type="checkbox" formControlName="spinsterIsDivorce" />
            <small style="font-size: 15px;">Is a divorcee?</small>
          </label>


        </div>


        <div class="form-section mt-4">
          <h5 class="form-section-heading mb-3">WITNESS DETAILS</h5>
          <div class="body">
            <div class="row g-3">

              <div class="col-md-4">
                <div class="field">
                  <label class="mb-0 required">SURNAME</label>
                  <input type="text" class="form-control mt-0" formControlName="spinsterWitnessSurname"
                    maxlength="60" />

                </div>
              </div>

              <div class="col-md-4">
                <div class="field">
                  <label class="mb-0 required">FIRST NAME</label>
                  <input type="text" class="form-control mt-0" formControlName="spinsterWitnessFirstName"
                    maxlength="60" />

                </div>
              </div>

              <div class="col-md-4">
                <div class="field">
                  <label class="mb-0 required">MIDDLE NAME</label>
                  <input type="text" class="form-control mt-0" formControlName="spinsterWitnessMiddleName"
                    maxlength="60" />

                </div>
              </div>

              <div class="col-md-4">
                <div class="field">
                  <label class="mb-0 required">EMAIL</label>
                  <input type="text" class="form-control mt-0" formControlName="spinsterWitnessEmail"
                    maxlength="30" />

                </div>
              </div>

              <div class="col-md-4">
                <div class="field">
                  <label class="mb-0 required">PHONE NUMBER</label>
                  <input type="text" class="form-control mt-0" formControlName="spinsterWitnessPhoneNumber"
                    maxlength="17" />

                </div>
              </div>

              <div class="col-4">
                <div class="field">
                  <label class="mb-0 required">ADDRESS</label>
                  <input type="text" class="form-control mt-0" formControlName="spinsterWitnessAddress"
                    maxlength="200" />

                </div>
              </div>

              <div class="col-md-4">
                <div class="field">
                  <label class="mb-0 required">SIGNATURE</label>
                  <div class="mt-2">
                    <a [href]="form.get('spinsterWitnessSignature').value" target="_blank">
                      <img
                        [src]="form.get('spinsterWitnessSignature').value"
                        alt="Signature"
                        class="img-fluid rounded border"
                        style="max-height: 200px; object-fit: contain;"
                      />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <div class="collapsable-form-section">
      <div class="collapsable-form-section-heading" role="button" data-bs-toggle="collapse"
        data-bs-target="#documentSection" aria-expanded="true">
        DOCUMENT UPLOADS
      </div>

      <div class="body collapse show" id="documentSection">



        <div class="form-section mt-4">
          <h5 class="form-section-heading mb-3">DOCUMENT UPLOADS</h5>

          <div class="row g-3">

            <div class="col-md-4">
              <div class="field">
                <label class="mb-0 required">CERTIFICATE OF OATH</label>
                <div class="mt-2">
                  <a [href]="form.get('oathCertificate').value" target="_blank">
                    <img
                      [src]="form.get('oathCertificate').value"
                      alt="Certificate of Oath"
                      class="img-fluid rounded border"
                      style="max-height: 200px; object-fit: contain;"
                    />
                  </a>
                </div>
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>

  </form>


</div>

<div class="modal-actions-wrapper"
    *ngIf="hasAccess(['CAN_APPROVE_MARRIAGE_REGISTRATION']) && dialogData?.approvalStatus == 'PENDING' ">
    <button type="submit" class="btn flex-btn btn-danger w-100" (click)="queryApplication()">
        <span>DECLINE</span>
        <span class="spinner-light" *ngIf="isQueryingApplication"></span>
    </button>

    <button type="submit" class="btn flex-btn btn-success w-100" (click)="approveApplication()">
        <span>APPROVE</span>
        <span class="spinner-light" *ngIf="isApprovingApplication"></span>
    </button>
</div>